import './policy.scss';
import { Footer } from '../../components/Footer';

function UsePolicy() {
  return (
    <div className="policy-wrapper">
      <div
        className="policy-content"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/image/policy-bg.png)` }}
      >
        <div style={{ width: '100%', paddingTop: 12 }}>
          <span style={{ color: '#fff', paddingLeft: 12, fontSize: 16 }}>
            《呱呱模玩使用协议》2026年7月1日生效版本
          </span>
        </div>
        <div className="policy-scroll-area">
        <p
          style={{
            color: '#191430',
            whiteSpace: 'pre-line',
            paddingInline: 12,
            paddingBottom: 12,
            marginInline: 12,
            marginBottom: 12,
            fontSize: 13,
            backgroundColor: 'rgba(255,255,255,0.7)',
            borderRadius: 12,
            border: '1px solid #ffffff',
          }}
        >
          <p style={{ color: '#191430', textAlign: 'center', fontSize: 16 }}>【特别提示】</p>
          {`《呱呱模玩使用协议》(简称为“本协议”) 是您与呱呱模玩之间关于呱呱模玩平台中提供的服务的法律协议。
在此特别提醒，请您在使用呱呱模玩服务前阅读并充分理解本协议，特别是免除或者限制责任的相关条款，双方确认前述条款不属于《中华人民共和国民法典》第四百九十七条规定的“不合理地免除或者减轻其责任、加重对方责任、限制、排除对方主要权利”条款，您认可其合法性及有效性。
呱呱模玩可能会根据呱呱模玩整体规划等，对本协议进行修改或变更，修改或变更的内容将于相关页面进行公告。若您不同意呱呱模玩或本协议的前述修改或变更，您可停止使用呱呱模玩服务。您使用呱呱模玩服务即视为您接收并同意本协议所有条款，包括但不限于前述修改及变更，请您在勾选同意本协议前道慎阅读并理解相关内容，如您勾选同意即视为您自此发生的交易均受该协议约束，包括但不限于前述修改及变更。如您违反本协议约定，呱呱模玩有权随时中止或停止该服务。
如果您因年龄（未满18周岁）、智力等因素而不具有完全民事行为能力，请在法定监护人的陪同下阅读本协议。 本协议是基于 《呱呱模玩用户使用协议》、《呱呱模玩服务协议》以及呱呱模玩相关协议规范（统称为“呱呱模玩服务条款”）制定，与其是不可分割的。同时，呱呱模玩不时发布的关于呱呱模玩的相关协议、服务规则、公告、活动规则等各类规则也是本协议的一部分，您在使用呱呱模玩服务的同时应遵守本协议。
适用范围：本协议适用于通过销售的所有商品和服务（以下统称“商品”）。
特别提示：由于您使用的软件版本，设备、操作系统等不同以及第三方原因可能导致您实际可使用的具体服务有差别，由此可能给您带来的不便，您表示理解，同时并不会因此向呱呱模玩及其关联公司提出任何主张或追究呱呱模玩及其关联公司任何责任。
一、缺货/延期:
(1）由于市场变化、供应商生产计划变化、系统问题、不可抗力等因素影响，您所提交的订单信息中的商品可能存在缺货情形。在此情形下，呱呱模玩将以有效方式（包括但不限于在呱呱模玩发布公告，发送邮件，向您提供的联系电话发送手机短信，向您的呱呱模玩账号发送消息或系统通知等方式）通知您并提供解决方案（包括但不限于取消订单、换货、调货等方式）。请您在未收到商品之前留意通知；
(2）呱呱模玩将在一周内以短信或电话的方式向您发送两次通知。请您在收到通知后14天内主动联系在线客服，否则呱呱模玩将有权取消订单，由此给您带来的不便敬请谅解；
(3）缺货商品是否补货不再另行通知，如您对此赏品感兴趣，请您随时关注；
(4）请您知悉呱呱模玩中的预售商品，客服给出的发货时间为参考时间，该参考时间可能因库存状况、送货时间、送货地点等客观因素存在误差，具体发货时间以商品实际发货时间为准；
(5）请您同样知悉预售类商品的实际发货时间会因受制作周期、物流周期、质检返工、不可抗力等诸多因素影响时效存在误差，导致预售类商品的实际发货时间可能延迟，您对上述情形表示同意及理解。
二、使用说明：
(1) 全场满99元享受包邮服务，不足99元时，非偏远地区需补10元，偏远地区（新疆、西藏）需补20元邮费。呱呱模玩商品可配送区域为中国大陆地区(除特殊偏远地区），收件地址在此之外的区域请勿下单。呱呱模玩商品默认发韵达或京东。部分偏远地区可能为其他合作物流公司；
(2) 签收商品时，请您亲自检查包装情况，在快递员面前验货，并在确认无误后签收；
(3) 呱呱模玩包含一个或多个不同系列的商品，每个系列中一整盒对应的初始商品数量可能因种类不同而不同。呱呱模玩商品可能存在拆盒售卖，由平台二次包装的情况，请您谨慎考虑后购买；
(4) 部分预售商品出版后可能会先通过跨境方式至境内进行发货，大约需要45天时间，无需您提供个人信息，平台会在商品到达境内后第一时间通知您，届时可在赏柜进行发货操作；
(5）呱呱模玩商品随机出现，并设有防沉迷机制，触发后将限制消费，具体以页面出现的提示为准，请您理性消费。
三、法律适用与争议解决:
(1) 呱呱模玩不行使、未能及时行使或者未充分行使本协议或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响呱呱模玩在将来行使该权利；
(2）本协议的订立、效力、解释、履行、修改和中止以及争议的解决适用中华人民共和国法律。因解释和履行本协议而发生的任何争议，应尽量通过友好协商的方式加以解決。如果在一方向其他方发出要求协商解决的书面通知后30天之内争议仍然得不到解决，则争议各方一致同意提交中国安徽蚌埠市怀远县仲裁委员会解决。仲裁裁决是终局的，对双方均有约束力。
四、其他：
(1) 除非另有证明，储存在呱呱模玩服务器上的数据是您使用呱呱模玩服务的唯一有效证据；
(2) 若您存在以下不正当行为，一经发现呱呱模玩有权采用包括但不限于暂停发货、取消订单、拦截已发货的订单，限制账户权限等措施：
1.用户利用技术手段或其他方式在呱呱模玩套取赏品、运费或其他利益；
2.呱呱模玩认定的其他不正当行为。
您确认并同意，前述措施将同样适用于您的关联账号。
五、免责事由：
(1）您知悉并同意，呱呱模玩不因下述任一情况可能导致的任何损害赔偿承担责任，包括但不限于财产、收益、数据资料等方面的损失或其他无形损失：
1.因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力值因素导致系统或服务不能正常运作；
2.由于黑客攻击、电信部门技术调整或故障、系统维护等原因而造成的服务中断或者延迟；
3.由于政府命令、法律法规的变更、司法机关及行政机关的命令、裁定等原因而导致的系统服务中断、终止或延迟；
4.由于您将账号密码告知他人或末保管好自己的密码或与他人共享账号或任何其他非呱呱模玩的过错导致您的个人资料泄露；
5.由于与呱呱模玩链接或合作的其他网站所造成的的银行账户信息、身份信息泄露及由此而导致的任何法律争议和后果；
6.您(包括未成年人用户）向呱呱模玩提供错误、不完整、不实信想等，遭受任何其他损失；
7.如因系统维护或升级的需要而暂停服务时，我们将尽可能事先通知。对于服务或终端的终止而给您造成的任何损失，我们无需对您或任何第三方承担任何责任。
(2) 您理解呱呱模玩对您的任何请求或行动要求均需要合理时间，在呱呱模玩响应您请求和行动时可能无法避免或阻止侵害后果的形成或扩大，除呱呱模玩存在法定过错外，呱呱模玩不承担责任。

呱呱模玩应用内的一切商业活动与Apple Inc无关，最终解释权归怀远模玩文化有限公司所有。`}
        </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default UsePolicy;
